import { get } from "lodash"

export const getAttributeFromWindow = path => get(window, path)
